import script from "./TestLink.vue?vue&type=script&setup=true&lang=js"
export * from "./TestLink.vue?vue&type=script&setup=true&lang=js"

import "./TestLink.vue?vue&type=style&index=0&id=12b6b616&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12b6b616"]])

export default __exports__